import axios, { Response } from 'services';

export interface IBalanceHistoryResponse {

};
export const getBalanceHistory = (): Response<IBalanceHistoryResponse> => {
	return axios.get(`/profile/charges`);
};

export interface IRequestInvoicePayload {
	tin: string;
	amount: string;
};
export const requestInvoice = (payload: IRequestInvoicePayload): Response<void> => {
	return axios.post(`/profile/invoice_request`, payload);
};
